import React from "react";
import { Link } from "react-router-dom";
import AuthCard, { PRIMARY_BUTTON } from "components/AuthCard";
import { AppPath } from "utils/constants";
import { JA } from "utils/strings.ja";

// Back to the list each role lands on: the guard on /service-provider sends
// everyone else to theirs, and a signed-out visitor to the login screen. Not
// "/", which is the login screen itself and signs the session out.
const NotFound = () => (
  <AuthCard title={JA.notFound.title} description={JA.notFound.description}>
    <Link to={AppPath.ServiceProvider} className={`${PRIMARY_BUTTON} block text-center`}>
      {JA.notFound.back}
    </Link>
  </AuthCard>
);

export default NotFound;
